import React, { useContext, useEffect, useState } from "react";
import { useApiClient } from "../../context/ApiClientContext";
import { Backdrop, Box, CircularProgress, createTheme, Pagination, ThemeProvider, useMediaQuery, useTheme } from "@mui/material";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { DataContext } from "./index";
import ComponentBackdrop from "../../components/backdrop";
import CustomTheme from "../../theme/customTheme";
import CustomToolbar from "../../utils/customToolbar";

export default function EmployeeList({ currentPage, totalPage, pageSize, id, handleShowButton }) {
  const rows = useContext(DataContext);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [currentPage, pageSize, id]);

  const fetchData = async (id) => {
    await fetchDataAndUpdateList(currentPage, id);
  };

  const fetchDataAndUpdateList = async (page, eventId) => {
    // console.log('dataId', eventId);
    let actualId;

    if (typeof eventId === 'object' && eventId !== null) {
      actualId = eventId.eventId || eventId.id || eventId.value;
    } else {
      actualId = eventId;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `${mobileApiUrl}mission/mission-details?missionId=${actualId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
        }
      );
      const participants = response.data.data.employeesList;
      const dataWithKeys = participants.map((item) => ({
        ...item,
        id: item.employeeId,
      }));
      setFilteredDataList(dataWithKeys);

    } catch (error) {
      if (error?.response?.status === 404) {
        setFilteredDataList([]);
        console.log("No participants found");
      } else {
        console.error("An error occurred:", error?.response?.statusText);
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "employeeId",
      headerName: "#",
      width: 80,
    },
    {
      field: "code",
      headerName: "Employee Code",
      width: 200,
    },
    {
      field: "fullName",
      headerName: "Full Name",
      width: 100,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      flex: 1,
    },
  ];


  return (
    <div>
      <Box
        // m="8px 0 0 0"
        style={{
          width: "100%",
          height:360,
        }}
      >
        {/* <ComponentBackdrop open={open} close={handleClose} /> */}
        {/* <ThemeProvider theme={CustomTheme}> */}
        <DataGrid
          columns={columns}
          rows={filteredDataList}
          showToolbar
           slots={{ toolbar: CustomToolbar }}
          pageSizeOptions={[5, 10, { value: 50, label: "50" }]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10 },
            },
          }}
          slotProps={{
            
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
            disableToolbarButton: {
              csvOptions: "true",
              printOptions: "true"
            },
            toolbar: {
              title: "Employee Listing",
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true }
            },
          }}
          disableRowSelectionOnClick
          localeText={{ noRowsLabel: "No records found" }}
        />
        {/* </ThemeProvider> */}
      </Box>
    </div>
  );
}

